// @mui
import { enUS as coreEnUS, esES as coreEsES, ptBR as corePtBR } from "@mui/material/locale";
import { enUS, esES, ptBR } from "@mui/x-date-pickers/locales";

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: "spanish",
    value: "es",
    systemValue: {
      components: {
        ...esES.components,
        ...coreEsES.components,
      },
    },
    twoLetterISOValue: "es-AR",
    icon: "flagpack:es",
  },
  {
    label: "english",
    value: "en",
    systemValue: {
      components: {
        ...enUS.components,
        ...coreEnUS.components,
      },
    },
    twoLetterISOValue: "en-US",
    icon: "flagpack:us",
  },
  // {
  //   label: "portuguese",
  //   value: "pt",
  //   systemValue: {
  //     components: {
  //       ...ptBR.components,
  //       ...corePtBR.components,
  //     },
  //   },
  //   twoLetterISOValue: "pt-BR",
  //   icon: "flagpack:br",
  // },
];

export const defaultLang = allLangs.find(lang => lang.value === "en"); // English

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
